const PAFormPassToggleHandler = form => {
    // console.info("p");
    const passToggleButtons = form.querySelectorAll('button.btn-password-toggle');

    passToggleButtons.forEach(toggleButton => {
        toggleButton.addEventListener('click', () => {
            toggleButton.classList.toggle('show-pass');
            const passInput = toggleButton.nextElementSibling;
            if (passInput && passInput.tagName.toLowerCase() === 'input') {
                if (toggleButton.classList.contains('show-pass')) {
                    passInput.setAttribute('type', 'text');
                } else {
                    passInput.setAttribute('type', 'password');
                }
            }
        });
    });
};

const PAFormInit = () => {
    const PAFormClasses = [
        'pa-login-form-wrapper',
        'pa-register-form-wrapper'
    ];

    PAFormClasses.forEach(formClassname => {
        const forms = document.querySelectorAll(`.${formClassname}`);

        forms.forEach(form => {
            PAFormPassToggleHandler(form);
        });
    });
};

document.addEventListener('DOMContentLoaded', PAFormInit);
